import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Sidebar from '../Sidebar';
import { Redirect, Route } from 'react-router-dom';

import './router.scss';
import AllRightsReserved from '../AllRightsReserved';
import { Button } from '../../Atoms';

const AdminRoute = ({
  roles,
  noSidebar,
  userInfo,
  component: Component,
  prevPath,
  ...rest
}) => {
  const { role } = userInfo || {};
  const history = useHistory();

  const handleNavigate = () => {
    history.push('/feedback');
  };

  return (
    <Route
      {...rest}
      exact={true}
      render={(props) =>
        userInfo ? (
          roles.includes(role) ? (
            <Fragment>
              {noSidebar ? (
                <div className="route-wrapper">
                  <Component {...props} />
                  <AllRightsReserved />
                </div>
              ) : (
                <div className="d-flex admin-route">
                  <Sidebar {...props} userInfo={userInfo} />
                  <div className="admin-route-wrapper">
                    <div className="feed-header">
                      <h5>Welcome, {userInfo.first_name}</h5>
                      <Button size="md" color="white" onClick={handleNavigate}>
                        GIVE FEEDBACK
                      </Button>
                    </div>
                    <div className="w-100">
                      <Component
                        {...props}
                        userInfo={userInfo}
                        prevPath={prevPath}
                      />
                    </div>
                    <div className="footer-text">
                      <p>
                        Peak Mind is not a mental health provider.  Please call
                        911 for life threatening emergencies or 988 for mental health emergencies.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </Fragment>
          ) : (
            <Redirect to="/" />
          )
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

const mapStateToProps = (state) => ({
  userInfo: state.auth.userInfo.info,
});

export default connect(mapStateToProps)(AdminRoute);
